<template>
  <form @submit="onFormSubmit">
    <FormInputText
      label="Phone Number"
      class="mb-4"
      name="sms"
      type="tel"
    />
    <FormSubmitButton
      type="submit"
      :is-loading="isSubmitting"
      class="w-full"
    >
      Send Receipt
    </FormSubmitButton>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import z from "zod"
import { ApiError } from "@/api"

const props = defineProps<{
  objectId: string
  receiptType: "order" | "transaction"
}>()

const emit = defineEmits<{
  (eventName: "submit-success"): void
}>()

const formSchema = z.object({
  sms: z.string().min(1, "Please enter a phone number"),
})

const { handleSubmit, isSubmitting, setFieldError } =
  useForm({
    validationSchema: toTypedSchema(formSchema),
    initialValues: { sms: "" },
  })

const onFormSubmit = handleSubmit(async (formValues) => {
  try {
    props.receiptType === "order"
      ? await sendOrderReceipt(props.objectId, formValues)
      : await sendTransactionReceipt(
          props.objectId,
          formValues
        )
    toast.success(`Receipt sent to ${formValues.sms}`)
    emit("submit-success")
  } catch (error) {
    if (error instanceof ApiError) {
      const smsValidationError =
        error?.requestErrors?.body?.sms

      if (smsValidationError) {
        setFieldError("sms", smsValidationError)
        return
      }
      if (error.code === "sms-service-disabled") {
        toast.error("SMS service is disabled")
      } else {
        toast.error("Failed to send receipt")
      }
    } else {
      toast.error("Failed to send receipt")
    }
  }
})
</script>
